<script setup lang="ts">
import { type Collection, ProductTypes } from "~/types";
import { repository } from "~/repository";
import type { PropType } from "vue";
import { useAuthStore } from "~/stores/auth/store";

const props = defineProps({
  video: {
    type: Object as PropType<Collection & { onAir: boolean }>,
    required: true,
  },
});

const authStore = useAuthStore();
const { authenticated, user, subscription } = storeToRefs(authStore);

const headerText = computed(() => {
  if (props.video.entitlements_rule === "none") {
    if (!authenticated.value) {
      return "Create a free account to unlock video";
    } else if (
      subscription.value.interval === ProductTypes.NONE &&
      !user.value.emailVerified
    ) {
      return "Verify your email to unlock video";
    }
  } else {
    if (subscription.value.interval === ProductTypes.NONE) {
      return "Subscribe to unlock video";
    } else {
      return "Upgrade to unlock video";
    }
  }
  return "";
});

const actionBtnText = computed(() => {
  if (props.video.entitlements_rule === "none") {
    if (!authenticated.value) {
      return "Sign Up/Log In";
    } else if (
      subscription.value.interval === ProductTypes.NONE &&
      !user.value.emailVerified
    ) {
      return "Verify now";
    }
  } else {
    if (subscription.value.interval === ProductTypes.NONE) {
      return "Subscribe now";
    } else {
      return "Upgrade now";
    }
  }
  return "";
});

async function handleActionOnClick() {
  let path = "";
  if (props.video.entitlements_rule === "none") {
    if (!authenticated.value) {
      path = "/register";
    } else if (
      subscription.value.interval === ProductTypes.NONE &&
      !user.value.emailVerified
    ) {
      await repository.auth.requestEmailCode();
      path = "/register/verify-email";
    }
  } else {
    if (subscription.value.interval === ProductTypes.NONE) {
      path = "/register/select-plan";
    } else {
      path = "/account/change-plan";
    }
  }

  await navigateTo(path);
}
</script>

<template>
  <div
    class="mt-5 bg-[url('~/assets/images/locked-desktop.png')] bg-cover bg-center"
    :class="['flex flex-col px-4 py-10 lg:p-14']"
  >
    <div class="mb-6 flex items-center text-xl font-bold lg:text-2xl">
      <font-awesome-icon :icon="['far', 'lock-keyhole']" class="mr-4" />
      {{ headerText }}
    </div>
    <div class="mb-6 max-w-screen-md">
      Watch 100+ days a year of LIVE poker tournaments, including the WSOP and
      enjoy exclusive, NEW poker shows such as No Gamble, No Future & High
      Stakes Poker!
    </div>
    <div>
      <Button
        :label="actionBtnText"
        severity="secondary"
        :pt="{ root: ['bg-white'], label: 'text-black hover:text-white' }"
        :pt-options="{ mergeProps: true }"
        @click="handleActionOnClick"
      />
    </div>
  </div>
</template>

<style scoped></style>
